import * as Blockly from 'blockly/core';
import { blockWhile, indent, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['while_time'] = function (block: Blockly.Block): string {
        const duration = gen.valueToCode(block, 'DURATION', 0) || '1000';
        const unit = block.getFieldValue('UNIT') as string;
        const ms = unit === 's' ? `(${duration}) * 1000UL` : duration;
        const body = gen.statementToCode(block, 'DO');
        // 同じスコープに複数置いても _wt_start が重複宣言にならないよう、ブロックごとに {} で囲む
        const loop = stmt('unsigned long _wt_start = millis()') + blockWhile(`millis() - _wt_start < ${ms}`, body);
        return `{\n${indent(loop)}}\n`;
    };
}
